<template>
  <hr :class="className" />
</template>

<script>
import { twMerge } from 'tailwind-merge';
export default {
  name: 'GdSeparator',
  props: {
    classes: { type: String, default: ''}
  },
  computed: {
    className() {
      return twMerge('border-secondary-light h-px w-full my-4', this.classes);
    }
  }
};
</script>